import { render, staticRenderFns } from "./TotpSetup.vue?vue&type=template&id=6eab56fa&scoped=true"
import script from "./TotpSetup.vue?vue&type=script&lang=js"
export * from "./TotpSetup.vue?vue&type=script&lang=js"
import style0 from "./TotpSetup.vue?vue&type=style&index=0&id=6eab56fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eab56fa",
  null
  
)

export default component.exports